import { render, staticRenderFns } from "./ClientPortalFormats.vue?vue&type=template&id=57db40a7&"
import script from "./ClientPortalFormats.vue?vue&type=script&lang=js&"
export * from "./ClientPortalFormats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports